import React, { useMemo } from "react";
import { BaseButton } from "./BaseButton";
import useNavigate from "src/hooks/usePartnerNavigate";
import { useModal } from "src/recoil/modalState/hook";

type Props = {
  to: string;
  title?: string;
};

const EditCancelButton = ({ to, title }: Props) => {
  const isEditPage = useMemo(() => to.includes("detail"), [to]);

  const navigate = useNavigate();
  const { setBaseModal } = useModal();

  const handleCancel = () => {
    // 수정페이지 X > 등록 페이지인 경우 모달 없이 페이지 이동
    // if (!isEditPage) {
    //   navigate(to);
    //   return;
    // }

    setBaseModal({
      isOpen: true,
      title: "현재 페이지에서 나가시겠습니까?",
      children: (
        <span>
          입력 중인 내용이 있는 경우, <br /> 저장을 하지 않은 정보는 사라집니다.
        </span>
      ),
      btnLeftTitle: "머무르기",
      btnRightTitle: "나가기",
      onClick: () => {
        navigate(to);
        setBaseModal({ isOpen: false });
      },
      onClose: () => {
        setBaseModal({ isOpen: false });
      },
    });
  };

  return <BaseButton title={title || (isEditPage ? "수정취소" : "취소")} className="color-white size-large mr10" onClick={handleCancel} />;
};

export default EditCancelButton;
